export const SITE = {
  name: "Advantage Primary Health",
  phone: "(928) 327-7528",
  phoneHref: "tel:+19283277528",
  address: "6546 E 2nd St, Suite C, Prescott Valley, AZ 86314",
  addressShort: "6546 E 2nd St, Suite C",
  city: "Prescott Valley, AZ 86314",
  hours: "Wednesday–Sunday, 8:00 AM–8:00 PM",
  hoursNote: "By appointment",
  bookUrl: "https://consumer.scheduling.athena.io/?locationId=35522-1",
  reviewsUrl:
    "https://www.google.com/search?sca_esv=638675f18f681488&authuser=5&sxsrf=APpeQnuAu8zOkSpSqMehglDo2eBJj6aP2A%3A1789239544721&q=Advantage%20Primary%20Health&stick=H4sIAAAAAAAAAONgU1I1qLAwN0oxMjVMNUkyNjKxTEuyMqgwS05JNU1NtUw2STJNNElNWcQq4ZhSlphXkpieqhBQlJmbWFSp4JGamFOSAQAfU3azRAAAAA&mat=CQW17Vs3Oe5g&ved=2ahUKEwi9tezb3OmWAxWHLUQIHS_fEv8QrMcEegQIGhAC",
  mapEmbed:
    "https://www.google.com/maps?q=6546+E+2nd+St+Suite+C,+Prescott+Valley,+AZ+86314&output=embed",
  emergencyNote:
    "For life-threatening emergencies, call 911 or go to the nearest emergency room.",
  insurance: [
    "AHCCCS",
    "UnitedHealthcare",
    "Aetna",
    "Imperial Health",
    "Medicare",
    "Cigna Healthcare",
    "AZ Complete Health",
    "Ambetter",
    "Wellcare",
    "Self-Pay",
  ],
  outOfNetwork: ["Devoted Health", "Blue Cross Blue Shield (BCBS)"],
  outOfNetworkDisclaimer:
    "Out-of-network coverage and patient costs may vary depending on your specific insurance plan. Please contact our office to discuss your coverage before scheduling an appointment.",
  serviceAreas: ["Prescott Valley", "Prescott", "Chino Valley", "Dewey-Humboldt"],
};

export const SERVICES = [
  {
    slug: "primary-care",
    number: "01",
    icon: "Stethoscope",
    name: "Primary Care",
    tagline: "Ongoing, personalized care for adults and families.",
    short:
      "Preventive care, routine visits, and an ongoing relationship with a provider who knows you.",
    metaTitle: "Primary Care in Prescott Valley, AZ | Advantage Primary Health",
    metaDesc:
      "Personalized primary care for adults and families in Prescott Valley, AZ. Evening and weekend appointments. Now accepting new patients.",
    intro:
      "Good health is built over time, not in a single visit. At Advantage Primary Health, primary care means having a provider who knows your history, listens to your concerns, and helps you stay ahead of your health—not just react when something goes wrong. From routine checkups and preventive care to everyday health concerns, we care for adults and families across Prescott Valley, Prescott, Chino Valley, and Dewey-Humboldt—with evening and weekend appointments designed around real life.",
    whoFor: [
      "Adults looking for a long-term primary care provider",
      "Families who want one trusted practice for everyone",
      "New Prescott Valley residents establishing care",
      "Anyone who prefers unhurried, personal appointments",
    ],
    faqs: [
      {
        q: "Do I need a primary care provider if I feel healthy?",
        a: "Yes. Preventive and routine visits help catch small concerns before they become bigger ones, and they give your provider a baseline for your health over time.",
      },
      {
        q: "How do I become a new patient?",
        a: "We are now accepting new patients. Use the Book Online button for a standard appointment, or call (928) 327-7528 with any questions before your visit.",
      },
      {
        q: "Can I get a same-day primary care appointment?",
        a: "Same-day appointments are often available by phone. Call our office at (928) 327-7528 and we will do our best to fit you in.",
      },
    ],
  },
  {
    slug: "pediatric-care",
    number: "02",
    icon: "Baby",
    name: "Pediatric Care",
    tagline: "Family-centered care in a space where kids feel welcome.",
    short:
      "A welcoming, kid-friendly environment and appointment times that work around school and work.",
    metaTitle: "Pediatric Care in Prescott Valley, AZ | Advantage Primary Health",
    metaDesc:
      "Family-centered pediatric care in Prescott Valley with evening and weekend appointments, so kids miss less school and parents miss less work.",
    intro:
      "A trip to the doctor should feel safe, calm, and maybe even a little friendly. At Advantage Primary Health, pediatric care is family-centered: a welcoming environment for children, a provider who takes time with both kids and parents, and appointment options built around family schedules. With evening and weekend availability, parents can often avoid pulling a child from school or missing work to get the care their family needs.",
    whoFor: [
      "Parents who do not want to pull their child from school for a visit",
      "Families looking for a welcoming, kid-friendly clinic",
      "Children and teens who need routine or timely care",
      "Families who want one practice for parents and kids alike",
    ],
    faqs: [
      {
        q: "Do you see children at Advantage Primary Health?",
        a: "Yes. We provide family-centered pediatric care in a welcoming environment. Call our office at (928) 327-7528 to ask about care for your child's age and needs.",
      },
      {
        q: "Can my child be seen after school or on weekends?",
        a: "Yes. We offer evening and weekend appointments Wednesday through Sunday, 8:00 AM–8:00 PM, specifically so families have options outside school and work hours.",
      },
      {
        q: "How do I book a pediatric appointment?",
        a: "Use the Book Online button for standard appointments, or call (928) 327-7528 to ask about same-day availability.",
      },
    ],
  },
  {
    slug: "hormone-replacement",
    number: "03",
    icon: "Activity",
    name: "Hormone Replacement",
    tagline: "Careful, personalized evaluation before any treatment begins.",
    short:
      "A consultation-first approach to hormone health, with personalized evaluation and planning.",
    metaTitle: "Hormone Replacement in Prescott Valley, AZ | Advantage Primary Health",
    metaDesc:
      "Personalized hormone replacement evaluation and treatment planning in Prescott Valley, AZ. Every plan begins with a consultation.",
    intro:
      "Changes in energy, mood, sleep, or overall wellbeing can sometimes be connected to hormones—and they deserve more than a rushed conversation. Hormone replacement care at Advantage Primary Health begins with a personalized evaluation. Jeremy takes time to understand your symptoms, your history, and your goals before any treatment plan is discussed. There are no one-size-fits-all protocols here: your plan is built around you, monitored carefully, and adjusted over time based on how you respond.",
    whoFor: [
      "Adults noticing changes in energy, mood, sleep, or wellbeing",
      "Patients seeking a careful, medically supervised evaluation",
      "Anyone who wants a personalized plan rather than a generic protocol",
    ],
    faqs: [
      {
        q: "How do I know if hormone replacement is right for me?",
        a: "That starts with a conversation. Schedule an appointment for a personalized evaluation, where your symptoms, history, and goals are reviewed before any recommendations are made.",
      },
      {
        q: "What happens at the first appointment?",
        a: "Your first visit is a thorough consultation. Jeremy will listen to your concerns, review your health history, and discuss whether further evaluation or treatment planning makes sense for you.",
      },
      {
        q: "Are results guaranteed?",
        a: "No. Every patient responds differently, and no specific outcome can be promised. Care is monitored and adjusted over time based on your individual response.",
      },
    ],
  },
  {
    slug: "weight-management",
    number: "04",
    icon: "Scale",
    name: "Weight Management",
    tagline: "Provider-guided support for sustainable health goals.",
    short:
      "Personalized, provider-guided support focused on sustainable, realistic health goals.",
    metaTitle: "Weight Management in Prescott Valley, AZ | Advantage Primary Health",
    metaDesc:
      "Provider-guided weight management in Prescott Valley, AZ. Personalized, sustainable plans with regular follow-up. No gimmicks, no unrealistic promises.",
    intro:
      "Lasting change rarely comes from quick fixes. Weight management at Advantage Primary Health is provider-guided and personal: it starts with understanding your health history, your routine, and your goals, then building a practical plan you can actually sustain. You will follow up regularly, adjust as you go, and have a provider in your corner the whole way. No gimmicks, no unrealistic promises, and no judgment—just steady, personalized support.",
    whoFor: [
      "Adults ready for a sustainable, medically guided approach",
      "Patients who have tried diets without lasting results",
      "Anyone who wants accountability and regular follow-up",
    ],
    faqs: [
      {
        q: "Is this a quick-fix weight loss program?",
        a: "No. Our approach focuses on sustainable health goals built around your life, with regular follow-up and adjustments over time.",
      },
      {
        q: "Will I get a personalized plan?",
        a: "Yes. Every plan starts with an evaluation of your health history, routine, and goals, and is adjusted as you progress.",
      },
      {
        q: "Are medications part of weight management?",
        a: "When clinically appropriate, treatment options can be discussed during your visit. Every decision begins with a personalized evaluation.",
      },
    ],
  },
  {
    slug: "chronic-care-management",
    number: "05",
    icon: "HeartPulse",
    name: "Chronic Care Management",
    tagline: "Ongoing support that does not stop when the visit ends.",
    short:
      "Coordinated care, regular follow-up, and a provider who knows your story between visits.",
    metaTitle:
      "Chronic Care Management in Prescott Valley, AZ | Advantage Primary Health",
    metaDesc:
      "Ongoing chronic care management in Prescott Valley, AZ with coordinated care and regular follow-up from a provider who knows you.",
    intro:
      "Living with a long-term health condition is easier when you have a provider who knows your story and a plan that evolves with you. Chronic care management at Advantage Primary Health means regular follow-up, careful attention between visits, and coordination with specialists when needed—so nothing falls through the cracks. It is ongoing, relationship-based care, not a series of rushed transactions.",
    whoFor: [
      "Patients managing one or more long-term health conditions",
      "Anyone who wants consistent follow-up between visits",
      "People who value a provider who coordinates their broader care",
    ],
    faqs: [
      {
        q: "What is chronic care management?",
        a: "It is ongoing support for patients managing long-term health conditions—regular follow-up, monitoring over time, and coordination of your broader care.",
      },
      {
        q: "How often will I be seen?",
        a: "Your follow-up schedule is personalized to your needs and adjusted as your care plan evolves.",
      },
      {
        q: "Do you coordinate with specialists?",
        a: "Yes. When specialty care is part of your plan, we help coordinate so your care stays connected.",
      },
    ],
  },
  {
    slug: "lab-draws",
    number: "06",
    icon: "FlaskConical",
    name: "In-Office Lab Draws",
    tagline: "Lab work drawn right here in our office—by appointment, for our patients.",
    short:
      "In-office lab draws by appointment, so one less trip stands between you and your care.",
    metaTitle: "In-Office Lab Draws in Prescott Valley, AZ | Advantage Primary Health",
    metaDesc:
      "In-office lab draws by appointment for patients of Advantage Primary Health in Prescott Valley, AZ. Evening and weekend availability.",
    intro:
      "When lab work is part of your care, there is no need for a separate trip across town. Advantage Primary Health offers in-office lab draws by appointment for our patients—done in a familiar, comfortable setting, often at the same evening or weekend times as your other appointments. Your results come back to the provider who knows you, keeping your care connected in one place.",
    whoFor: [
      "Patients whose provider has ordered lab work as part of their care",
      "Anyone who prefers labs drawn in a familiar, comfortable office",
      "Busy adults and families who want evening or weekend lab appointments",
      "Patients who like keeping their care in one place",
    ],
    faqs: [
      {
        q: "Do I need to be a patient to use in-office lab draws?",
        a: "In-office lab draws are a service for our patients, typically ordered as part of your care. If you are not yet established with us, book a visit—we are accepting new patients.",
      },
      {
        q: "How do I schedule a lab draw?",
        a: "Lab draws are by appointment. Book online anytime or call (928) 327-7528 and we will find a time that fits your schedule.",
      },
      {
        q: "Can I get labs drawn in the evening or on weekends?",
        a: "Yes. Appointments are available Wednesday through Sunday, 8:00 AM–8:00 PM—the same convenient hours as the rest of our care.",
      },
    ],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Jeremy genuinely cared about getting to know me as a person, not just a patient. If you want a provider who truly listens and cares, go see Jeremy.",
    name: "Kyle E.",
  },
  {
    quote:
      "Great consultative approach. Fix real problems as they present themselves rather than creating or reinforcing them.",
    name: "John L.",
  },
  {
    quote: "Jeremy was remarkable. I highly recommend this practice.",
    name: "Barbara A.",
  },
];

export const FAQS = [
  {
    q: "Are you accepting new patients?",
    a: "Yes. Advantage Primary Health is now accepting new patients and families from Prescott Valley and the surrounding communities. Book online anytime or call (928) 327-7528.",
  },
  {
    q: "What insurance plans do you accept?",
    a: "We accept AHCCCS, UnitedHealthcare, Aetna, Imperial Health, Medicare, Cigna Healthcare, AZ Complete Health, Ambetter, and Wellcare. We also see patients with Devoted Health and Blue Cross Blue Shield (BCBS) on an out-of-network basis—coverage and patient costs may vary by plan, so please call our office at (928) 327-7528 to discuss your coverage before scheduling an appointment.",
  },
  {
    q: "Do you accept self-pay patients?",
    a: "Yes. Self-pay patients are welcome. Call our office at (928) 327-7528 with any questions before your visit.",
  },
  {
    q: "When are appointments available?",
    a: "Appointments are available Wednesday through Sunday, 8:00 AM–8:00 PM, by appointment.",
  },
  {
    q: "Do you offer evening and weekend appointments?",
    a: "Yes. Evening and weekend appointments are at the heart of what we do—care designed to fit your life, not the other way around.",
  },
  {
    q: "How do I book an appointment?",
    a: "Use the Book Online button anywhere on this site. It opens our secure Athena scheduling page in a new tab, where you can choose a time that works for you.",
  },
  {
    q: "How do I request a same-day appointment?",
    a: "Call our office at (928) 327-7528. Same-day appointments are handled by phone so we can find the best time for you.",
  },
  {
    q: "What areas do you serve?",
    a: "We serve Prescott Valley, Prescott, Chino Valley, and Dewey-Humboldt, Arizona.",
  },
  {
    q: "Do you provide pediatric care?",
    a: "Yes. We provide family-centered pediatric care in a welcoming environment, with evening and weekend appointments that help parents avoid missing school or work when possible.",
  },
  {
    q: "Do you offer in-office lab draws?",
    a: "Yes. We offer in-office lab draws by appointment for our patients—so when lab work is part of your care, there is no separate trip across town. Visit the In-Office Lab Draws page under Services, or call (928) 327-7528 to schedule.",
  },
  {
    q: "What should I do in a life-threatening emergency?",
    a: "Call 911 or go to the nearest emergency room immediately. Our practice is not equipped for life-threatening emergencies.",
  },
];

export const SERVICE_IMAGES = {
  "primary-care": {
    src: "/images/jeremy-consult.webp",
    alt: "Jeremy Pene, FNP-C talking with a patient during a primary care visit",
  },
  "pediatric-care": {
    src: "/images/pediatric-room.jpg",
    alt: "The pediatric exam room at Advantage Primary Health, with games and kid-friendly art",
  },
  "hormone-replacement": {
    src: "/images/care-desk.jpg",
    alt: "The care coordination desk at Advantage Primary Health",
  },
  "weight-management": {
    src: "/images/waiting-room.jpg",
    alt: "The welcoming waiting room at Advantage Primary Health",
  },
  "chronic-care-management": {
    src: "/images/jeremy-exam-portrait.webp",
    alt: "Jeremy Pene, FNP-C performing an exam with a patient",
  },
  "lab-draws": {
    src: "/images/exam-room.jpg",
    alt: "An exam room at Advantage Primary Health where in-office lab draws are performed",
  },
};
